import * as React from "react";
import * as PropTypes from "prop-types";
import * as ReactModal from "react-modal";

interface IModalProps {
  height?: string;
  width?: string;
  maxWidth?: string;
  onRequestClose: Function;
  isOpen: boolean;
  label: string;
}

export class Modal extends React.PureComponent<IModalProps, any> {
  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 3
      },
      content: {
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        margin: "auto",
        height: this.props.height || "300px",
        width: this.props.width || "90%",
        maxWidth: this.props.maxWidth || "500px",
        background: "#f1f1f1",
        padding: "0px",
        border: "1px solid #ddddde",
        borderRadius: "0px"
      }
    };

    return (
      <ReactModal
        isOpen={this.props.isOpen}
        style={modalStyle}
        contentLabel={this.props.label}
        onRequestClose={this.props.onRequestClose}
      >
        {this.props.children}
      </ReactModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Modal.tsx